export function isInQuietHours(timeZone: string): boolean {
    if (!timeZone) {
        return false;
    }

    try {
        const ianaTimezone = timeZone;

        // Get current time in customer's timezone
        const now = new Date();
        
        const options: Intl.DateTimeFormatOptions = { 
            timeZone: ianaTimezone,
            hour: 'numeric',
            hour12: false
        };
        
        // Format just the hour in 24-hour format
        const formattedTime = new Intl.DateTimeFormat('en-US', options).format(now);
        
        const customerHour = parseInt(formattedTime);
        
        // Check if current hour is between 8 PM (20) and 8 AM (8)
        const isQuiet = customerHour >= 20 || customerHour < 8;
        
        return isQuiet;
    } catch (e) {
        return false;
    }
}